export default {
    DATE_PICKER_DATE_FORMAT: "DD-MM-YYYY",
    DATE_FORMAT: "YYYY-MM-DD",
    REQUIRED_MESSAGE: "This field is required!"
}